
import MapView from '@/components/MapView';

const Index = () => {
    return <MapView />;
};

export default Index;